import BuildIcon from "@mui/icons-material/Build";
import React from "react";
import { ListStateIcon } from "../ListStateIcon/ListStateIcon";

interface ListStateIconToolProps {
    color?: string;
    noMargin?: boolean;
    tooltip?: string;
  }
  
export const ListStateIconTool = ({
    noMargin,
    tooltip,
    color,
}: ListStateIconToolProps) => (
    <ListStateIcon
        color={color}
        noMargin={noMargin}
        tooltip={tooltip}
        icon={BuildIcon}
    />
);
